
const BlogHero = () => {
  return (
    <section className="relative pt-16 pb-5 sm:pt-24 md:pt-32 md:pb-16 bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white">
      <div className="absolute inset-0 opacity-15">
        <img
          src="https://public.readdy.ai/ai/img_res/ecdef45bf9d4100edc1f65befbbeb605.jpg"
          alt="Tin tức định cư Latvia - Blog và cẩm nang"
          title="Tin tức định cư Latvia cập nhật mới nhất"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-black/80"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <nav aria-label="Breadcrumb" className="mb-2.5 md:mb-4">
          <ol className="flex items-center text-[11px] sm:text-xs md:text-sm text-gray-400">
            <li>
              <a href="/" className="hover:text-gold-400 transition-colors cursor-pointer">Trang chủ</a>
            </li>
            <li className="mx-1 sm:mx-1.5 md:mx-2">/</li>
            <li>
              <a href="/dinh-cu-latvia" className="hover:text-gold-400 transition-colors cursor-pointer">Định Cư Latvia</a>
            </li>
            <li className="mx-1 sm:mx-1.5 md:mx-2">/</li>
            <li className="text-gold-400">Blog</li>
          </ol>
        </nav>

        <h1 className="text-xl sm:text-3xl md:text-5xl font-bold mb-1.5 sm:mb-2 md:mb-4 font-serif leading-tight">
          Tin Tức & Cẩm Nang <strong>Định Cư Latvia</strong>
        </h1>
        <p className="text-[13px] sm:text-base md:text-lg text-gray-300 max-w-3xl leading-relaxed">
          Cập nhật chính sách, kinh nghiệm thực tế và hướng dẫn chi tiết về <strong>định cư Latvia</strong> cho người Việt Nam.
        </p>
      </div>
    </section>
  );
};

export default BlogHero;
